import React from 'react';

interface Props {
  width?: number;
  className?: string;
}

export const SolvHealthLogo = ({ width = 120, className }: Props) => {
  return <img alt="Solv" className={className} src="/images/logo/solv_health.svg" width={width} />;
};

export default SolvHealthLogo;
